import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import { AuthProvider } from './views/pages/auth/AuthContext'
import { AuthStdProvider } from './views/pages/auth/AuthContextStd'

createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <AuthStdProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </AuthStdProvider>
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
